import { PromiseEnvelope } from '@types';
import { apiV2 } from 'services/iclinic/api';
import { FetchListCBORequest } from './types';

export const fetchListCBO = (): PromiseEnvelope<FetchListCBORequest> =>
  apiV2.get('/tuss/cbocompare/?all');

export const fetchCreateTermCBO = (term: string) =>
  apiV2.post('tuss/cbocompare/', { term });
